export const TASK_DOCUMENT_STATES = {
  draft: "Draft",
  ready_for_review: "Ready for your review",
  waiting_for_engineering: "Waiting for engineering",
  engineering_accepted: "Engineering accepted",
  revision_needed: "Revision needed",
  frozen: "Waiting for engineering",
};

export function founderLifecycleLabel(lifecycle, projectionStage) {
  if (lifecycle && TASK_DOCUMENT_STATES[lifecycle]) return TASK_DOCUMENT_STATES[lifecycle];
  if (projectionStage === "Planning") return "Draft";
  if (projectionStage === "Ready for handoff") return "Ready for your review";
  if (projectionStage === "Waiting for engineering") return "Waiting for engineering";
  return "Draft";
}

export function conversationStateLabel(stage, frozen) {
  if (frozen || stage === "sent") return "Task sent to engineering";
  if (stage === "ready") return "Ready for your review";
  if (stage === "clarifying") return "Clarifying important decisions";
  return "Understanding your idea";
}

function itemPlain(item) {
  if (item == null) return "";
  if (typeof item === "string") return item;
  return (
    item.outcome ||
    item.explanation ||
    item.text ||
    item.selected ||
    item.what ||
    item.title ||
    ""
  );
}

function changedRequirementText(previous, next) {
  const before = previous?.requirements || [];
  const after = next?.requirements || [];
  const beforeById = new Map(before.map((item) => [item.id, item]));
  for (const item of after) {
    const prior = beforeById.get(item.id);
    if (!prior) return item.title || item.explanation || "";
    if (prior.title !== item.title || prior.explanation !== item.explanation) {
      return item.explanation || item.title || "";
    }
  }
  if (before.length !== after.length) {
    const removed = before.find((item) => !after.some((nextItem) => nextItem.id === item.id));
    return removed?.title || removed?.explanation || "";
  }
  return "";
}

export function proposalPreview(proposal = {}) {
  const previous = proposal.previousValue;
  const next = proposal.proposedValue;
  const beforeItem = itemPlain(previous) || changedRequirementText(next, previous);
  const afterItem = itemPlain(next) || changedRequirementText(previous, next);
  return {
    before: beforeItem || "The current Task wording.",
    after: afterItem || "An updated Task wording.",
    why: proposal.why || "You asked AI to update the Task.",
    implications: proposal.downstreamImplications || [],
  };
}

export function checkKindLabel(kind) {
  if (kind === "automated_test") return "Automated test";
  if (kind === "ci") return "CI requirement";
  if (kind === "runtime") return "Runtime check";
  if (kind === "documentation") return "Documentation check";
  return "Human check";
}
